var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvgOperator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17313_59581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0635 10.5C8.48889 10.5 7.86318 8.67309 7.25798 6.90642C6.68442 5.23176 6.09099 3.5 4.81349 3.5C4.51516 3.51754 4.22881 3.6235 3.99092 3.80438C3.75303 3.98526 3.57437 4.23287 3.47772 4.51566L2.64844 4.23666C2.67044 4.17086 3.20428 2.625 4.81349 2.625C6.71623 2.625 7.44383 4.74893 8.08599 6.62283C8.61471 8.16668 9.11412 9.625 10.0635 9.625C10.3618 9.60746 10.6482 9.5015 10.8861 9.32062C11.124 9.13974 11.3026 8.89213 11.3993 8.60934L12.2285 8.88834C12.2065 8.95414 11.6727 10.5 10.0635 10.5Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.25V7.4375H2.625V6.5625H1.75V0.875H0.875V12.25C0.875 12.4821 0.967187 12.7046 1.13128 12.8687C1.29538 13.0328 1.51794 13.125 1.75 13.125H13.125V12.25H1.75Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 6.5625H3.5V7.4375H4.375V6.5625Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 6.5625H5.25V7.4375H6.125V6.5625Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 6.5625H8.75V7.4375H9.625V6.5625Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 6.5625H10.5V7.4375H11.375V6.5625Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.5625H12.25V7.4375H13.125V6.5625Z",
    fill: "#232F6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17313_59581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgOperator);
export default __webpack_public_path__ + "static/media/avg-operator.52801c3f179a55953d90b4ef55dd231e.svg";
export { ForwardRef as ReactComponent };